<div class="modal-header">
    <h4 class="modal-title">Customer</h4>
</div>
<div class="modal-body">
    <dx-form [formData]="customer" [colCount]="2" *ngIf="customer">
        <dxi-item itemType="group">
            <dxi-item itemType="group" caption="Customer Information">
                <dxi-item dataField="companyName" [label]="{ text: 'Company' }" [isRequired]="true"></dxi-item>
                <dxi-item dataField="contactName" [label]="{ text: 'Contact' }"></dxi-item>
                <dxi-item dataField="email" [label]="{ text: 'Email' }">
                </dxi-item>
                    <dxi-item dataField="phone1" [label]="{ text: 'Ph 1' }"></dxi-item>
                    <dxi-item dataField="phone2" [label]="{ text: 'Ph 2' }"></dxi-item>
                <dxi-item dataField="fax"></dxi-item>
            </dxi-item>


        </dxi-item>

        <dxi-item itemType="group">
            <dxi-item itemType="group" caption="Address">
                <dxi-item dataField="billAddress1"></dxi-item>
                <dxi-item dataField="billAddress2"></dxi-item>
                <dxi-item dataField="billCity"></dxi-item>
                <dxi-item [visible]="customer.billCountry != 'OTHER'" dataField="billState" editorType="dxSelectBox" [editorOptions]="{ items: states }"></dxi-item>
                <dxi-item [visible]="customer.billCountry == 'OTHER'" dataField="billState"></dxi-item>
                <dxi-item dataField="billZip"></dxi-item>
                <dxi-item dataField="billCountry" [label]="{ text: 'Country' }" editorType="dxSelectBox" [editorOptions]="{ items: countries }"></dxi-item>
                <dxi-item *ngIf="customer.billCountry == 'OTHER'" dataField="billCountryOther"></dxi-item>
            </dxi-item>




            <!-- <dxi-item itemType="group" caption="Tax Info">
                <dxi-item dataField="taxCode" editorType="dxSelectBox" [editorOptions]="{ items: taxCodes, valueExpr: 'code', displayExpr: 'displayName' }"></dxi-item>
            </dxi-item> -->

            <!-- <dxi-item itemType="group" caption="Notes">
                <dxi-item [label]="{ text: 'Sales Note' }" [colSpan]="5">
                    <div *dxTemplate>
                        <dx-text-area [(value)]="customer.salesNote" [height]="100"></dx-text-area>
                    </div>
                </dxi-item>
            </dxi-item> -->
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
